@if (componentType(); as cmp) {
    @for (_ of [outletRemountKey()]; track _) {
        <ng-container *ngTemplateOutlet="widgetOutlet; context: { cmp }" />
    }
}

<ng-template #widgetOutlet let-cmp="cmp">
    <ng-container *ngComponentOutlet="cmp; inputs: outletInputs()" />
</ng-template>
